module.exports = __webpack_public_path__ + "static/media/sol.1a12a3e3.webp";